<template>
    <div>

    <!-- <el-dialog
        title="标题"
        :visible.sync="visible"
        width="900px"
    > -->
        <div id="printMe" ref="printContent" class="content">
            <div style="display: flex;align-items: center;justify-content: center;">
                入库单通知单
            </div>
            <div style="height:10px;"></div>
			<el-form v-model="storelinks">
				<div style="display: flex;justify-content: space-between;height:30px;">
                    <el-form-item label="仓库" style="width: 25%;">
                        <span>{{storelinks.warehouseName}}</span>
					</el-form-item>
                    <el-form-item  label="订单类型:" style="width: 25%;">
                        <span>{{storelinks.orderTypeName}}</span>
					</el-form-item>
					<el-form-item label="客户:" style="width: 25%;">
                        <span>{{storelinks.customerName}}</span>
					</el-form-item>
                    <el-form-item label="入库单号:" style="width: 25%;">
                        <span>{{storelinks.orderCode}}</span>
					</el-form-item>
					
				</div>
                <div style="display: flex;justify-content: space-between;height:30px;">
                   
                    <el-form-item label="供货单位:" style="width: 25%;">
                        <span>{{storelinks.csource}}</span>
					</el-form-item>
                    <el-form-item label="客户订单号:" style="width: 25%;">
                        <span>{{storelinks.customerOrderCode}}</span>
					</el-form-item>
                    <el-form-item label="车牌号码:" style="width: 25%;">
                        <span>{{storelinks.carNo}}</span>
					</el-form-item>
					<el-form-item label="备注:" style="width: 25%;">
                        <span>{{storelinks.memo}}</span>
					</el-form-item>   
                </div>
                <div style="height:30px;">
                    <el-form-item label="打印时间:" >
                        <span>{{storelinks.lastPrintDatetime}}</span>
                        <span style="padding-left:10px;">第</span>
                        <span style="padding:0 5px;">{{storelinks.printTimes}}</span>
                        <span>次打印</span>
					</el-form-item>   
                </div>
				
				<div style="width: auto;position: relative;">
                    <table  cellspacing="0" cellpadding="0" border="1" style="background-color: #fff;">
                        <thead>
                            <tr>
                                <td>商品编号</td>
                                <td style="width:300px;">商品名称</td>
                                <td>商品状态</td>
                                <td>批次</td>
                                <td style="width:60px;">计划数</td>
                                <td style="width:80px;">计划数EA</td>
                                <td style="width:60px;">实收</td>
                                <td>库位</td>
                                <td>备注</td>
                            </tr>
                        </thead>
                        <tbody >
                            <tr v-for="(item, index) in dataList" :key="index" >
                                <td>{{ item.pdtCode }}</td>
                                <td>{{ item.pdtName }}</td>
                                <td>{{ item.goodsStatusName }}</td>
                                <td>{{ item.batchNo }}</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.eaNum }}</td>
                                <td>{{ item.qtyReceived }}</td>
                                <td>{{ item.warehouseLocationName }}</td>
                                <td>{{ item.remark }}</td>
                            </tr>
                        </tbody>
                    </table>
                    
				</div>
				<div style="display: flex;padding-top:20px;height:30px;">
					<el-form-item label="制单人:" style="width: 25%;">
                        <span>{{ storelinks.createBy }}</span>
					</el-form-item>
					<el-form-item label="收货人:" style="width: 25%;">
                        <span>{{ storelinks.receiver }}</span>
					</el-form-item>
					<el-form-item label="装卸组:" style="width: 25%;">
                        <span>{{ storelinks.stevedore }}</span>
					</el-form-item>
					
				</div>
				<div style="display: flex;height:30px;">
					<el-form-item label="作业开始时间:" style="width: 50%;">
                        <span>{{ storelinks.beginDatetime }}</span>
					</el-form-item>
					<el-form-item label="作业结束时间:" style="width: 50%;">
                        <span>{{ storelinks.endDatetime }}</span>
					</el-form-item>
				</div>
			</el-form>
		</div>
        <!-- <template slot="footer"> -->
            <el-button type="primary" v-print="printObj" ref="printBtn">打印</el-button>
            <!-- v-print="printObj" -->
            <!-- <el-button @click="handleCancel()">关闭</el-button> -->
        <!-- </template> -->
    <!-- </el-dialog> -->
            
    </div>
</template>
<script>
export default {
    name: 'printModal',
    data() {
        return {
            exportData: "",
            reportData: '',
            visible: false,
            title: '表头',
            storelinks: {},
            dataList: [],
            printObj:{},
            printObj : {
                id: 'printMe',//id
                popTitle: "入库通知单",//自定义设置标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
        }
    },
    methods:{
        handlePrint() {
            // 处理点击事件后的逻辑
            // this.$emit('printMe');
            // console.log('无语至极')
           
            this.visible = true;
            this.init(38);
            // window.print()
            this.$refs.printBtn.click();
        },
        show(data) {
            this.visible = true;
            this.init(data);
            // this.creatQrCode(data);
        },
        close() {
            this.visible = false;
        },
        handleCancel() {
            this.close();
        },
        loadData(data) {
            //加载数据，注意换接口
            this.$get('xxxxx?no=' + data).then(res => {
                if (res.success) {
                this.reportData = res.result;
                }
            });
        },
        init(e){ //编辑查询
            // this.$api.warehouseWarrantPrint({
            //    orderId : this.$route.query.id
            // }).then(res=>{
            //     console.log('1111--', res.data)
            //     console.log('122--', JSON.parse(res.data.content))

            // })
            this.$api.getWarehouseWarrantInfoByID(e).then(res=>{
                // res.data=JSON.parse(this.$decrypt(res.data)).data
                this.storelinks=res.data
                // this.formData = JSON.parse(JSON.stringify(res.data))
                // console.log('根据ID查询--', res.data)
                this.orderID = res.data.id;
                this.orderInfo = res.data;
                this.dataList = res.data.children; 
            })
        }
    },
    mounted() {
        // this.init()
    },
}
</script>
<style lang="less" scoped>
    table {
   font-family: Arial, sans-serif;
   font-size: 14px;
   background-color: #f0f2f5;
   border-collapse: collapse;
   color: #454545;
   table-layout: auto;
   width: 100%;
   text-align: center;
   border-bottom-width: 1px;
   border-bottom-style: solid;
   border-bottom-color: #dadcde;
   thead {
     border-top-width: 1px;
     border-top-style: solid;
    border-top-color: #dadcde;
     line-height: 40px;
    font-weight: bold;
     color: #454c70;
   }
   tr {
     border-top-width: 1px;
     border-top-style: solid;
    border-top-color: #dadcde;
    line-height: 23px;
   }
   td{
     padding: 5px 10px;
    font-size: 14px;
     font-family: Verdana;
     width: 100px;
     word-break: break-all; // 元素换行
  }
   // 斑马纹效果stripe
   tr:nth-child(even) {
     background: #F5F7F9;
   }
   tr:nth-child(odd) {
    background: #FFF;
  }
 }
 .table-empty {
   min-height: 60px;
  text-align: center;
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   border-bottom: 1px solid #ebeef5;
  .table-empty-text {
     line-height: 60px;
     width: 50%;
   color: #909399;
 }
}
</style>
<style media="print" lang="less">
   @page {
       size:  241mm 159.5mm !important;
   	margin: 0 !important;
   }
    

    @media print {
        html {
            background-color: #ffffff;
            height: auto;
            margin: 0px;
            zoom: 89%;
        }
        // .content {
        //     transform: scale(0.95); /* 设置缩放比例 */
        //     transform-origin: top left; /* 确保从左上角开始缩放 */
        // }
        body {
            border: solid 1px #ffffff;
            // margin: 10mm 15mm 10mm 15mm;
            margin: 0 !important;
            padding: 0 !important;
        }
        /deep/ table {
            table-layout: auto !important;
        }
        /deep/ #pagetable table{
            table-layout: fixed !important;
        }
        .el-table__header-wrapper .el-table__header {
            width: 100% !important;
            border: solid 1px #f2f2f2;
        }
        .el-table__body-wrapper .el-table__body {
            width: 100% !important;
        }
        #pagetable table {
            table-layout: fixed !important;
        }
	}
	.client-name{
		text-align: center;
	}
</style>